import React, { ComponentType, FunctionComponent, useCallback } from 'react';
import { useTranslate } from 'react-admin';

/**
 * Concatenate two params in a select choice
 *
 * @param Component
 * @param params
 */
function withConcatenateParams(
  Component: ComponentType<any>,
  params: Record<string, any> | undefined
): FunctionComponent {
  const Extension: FunctionComponent<Record<string, any>> = (props) => {
    const t = useTranslate();
    if (!params) return null;
    const { first, second, third } = params;
    const optionRenderer = useCallback((choice: Record<string, any>) => {
      if (choice) {
        return `${choice[first]} - ${choice[second]}${
          third === 'validated_at'
            ? ` - ${t('field.validated_at.label', {
                date: new Date(choice[third]).toLocaleDateString('fr'),
              })}`
            : ''
        }`;
      }

      return null;
    }, []);

    return <Component {...props} optionText={optionRenderer} />;
  };

  Extension.displayName = `withExtension(ConcatenateParams)`;

  return Extension;
}

export default withConcatenateParams;
